{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/accordion-heading",
	"title": "Accordion Heading",
	"category": "design",
	"description": "Displays a heading that toggles the accordion panel.",
	"parent": [ "core/accordion-item" ],
	"usesContext": [
		"core/accordion-icon-position",
		"core/accordion-show-icon",
		"core/accordion-heading-level"
	],
	"supports": {
		"anchor": true,
		"background": {
			"gradient": true
		},
		"color": {
			"background": true,
			"gradients": true
		},
		"align": false,
		"interactivity": true,
		"spacing": {
			"padding": true,
			"__experimentalDefaultControls": {
				"padding": true
			},
			"__experimentalSkipSerialization": true,
			"__experimentalSelector": ".wp-block-accordion-heading__toggle"
		},
		"__experimentalBorder": {
			"color": true,
			"radius": true,
			"style": true,
			"width": true,
			"__experimentalDefaultControls": {
				"color": true,
				"radius": true,
				"style": true,
				"width": true
			}
		},
		"typography": {
			"__experimentalSkipSerialization": [
				"textDecoration",
				"letterSpacing"
			],
			"fontSize": true,
			"lineHeight": true,
			"__experimentalFontFamily": true,
			"__experimentalFontWeight": true,
			"__experimentalFontStyle": true,
			"__experimentalTextTransform": true,
			"__experimentalTextDecoration": true,
			"__experimentalLetterSpacing": true,
			"__experimentalDefaultControls": {
				"fontSize": true,
				"fontFamily": true
			}
		},
		"shadow": true,
		"visibility": false,
		"lock": false
	},
	"selectors": {
		"spacing": ".wp-block-accordion-heading .wp-block-accordion-heading__toggle",
		"typography": {
			"letterSpacing": ".wp-block-accordion-heading .wp-block-accordion-heading__toggle-title",
			"textDecoration": ".wp-block-accordion-heading .wp-block-accordion-heading__toggle-title"
		}
	},
	"attributes": {
		"openByDefault": {
			"type": "boolean",
			"default": false
		},
		"title": {
			"type": "rich-text",
			"source": "rich-text",
			"selector": ".wp-block-accordion-heading__toggle-title",
			"role": "content"
		},
		"level": {
			"type": "number"
		},
		"iconPosition": {
			"type": "string",
			"enum": [ "left", "right" ],
			"default": "right"
		},
		"showIcon": {
			"type": "boolean",
			"default": true
		}
	},
	"textdomain": "default"
}
